export default {
  text: null,
  from: null,
  to: null,
  typ: null,
  stav: null,
  priradeny: null,
  pripomienkujuciSubjekt: null,
  isNepriradeny: true,
};
